// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/53a412eb26d354b7a70c.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"7e85ac0008439eae8614","216":"83777825565060cb1ff2","217":"22ff2daeeb92d0d4c54e"}[chunkId] + ".chunk.js";
};